(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReturn', PharmaReturn);

	PharmaReturn.$inject = [ '$resource' ];

	function PharmaReturn($resource) {
		var resourceUrl = 'api/pharma-return/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();
